<template>
  <v-layout class="px-3" column justify-center align-center fill-height>
    <div>
      <v-fade-transition>
        <v-layout justify-center v-if="ready">
          <v-card class="rounded-5" width="100%" max-width="500px">
            <v-card-title class="justify-center font-weight-black">아이디 찾기</v-card-title>
            <v-card-subtitle class="text-center">
              등록된 휴대폰 번호로 문자 인증을 진행합니다.
            </v-card-subtitle>

            <v-card-text>
              <v-form @submit.prevent="requestAuth(phone)">
                <ValidationProvider name="phone" rules="required|phone" v-slot="{ errors }">
                  <v-text-field
                    v-model="phone"
                    label="휴대폰 번호"
                    outlined
                    dense
                    :error="errors.length > 0"
                    :error-messages="errors"
                    autofocus
                    autocomplete="phone"
                  ></v-text-field>
                </ValidationProvider>
              </v-form>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-fade-transition>
    </div>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      ready: false,
      phone: '',
    }
  },

  async mounted() {
    await this.$nextTick()
    this.ready = true
  },
}
</script>

<style></style>
